export interface IdBased {
    id: string
}


export default function findById<Type extends IdBased>(id: string, items: Type[]): Type {
    return items.find((item) => item.id === id)
}
